import React, { Component } from "react";
import { Modal, Upload } from "antd";
import { UploadOutlined } from '@ant-design/icons';

class ActivateService extends Component {
  state = {
    serviceContract: [],
    loading: false
  }

  // on Upload doc
  onUpload = (e) => {
    const { serviceContract } = this.state;
    const file = e?.file;
    file && this.getBase64String(file, (result) => {
      serviceContract[0] = {...e.file, imageUrl: result};
      this.setState({serviceContract})
    })
  }

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  render() {
    const { visible, onCancel, onActiveService } = this.props;
    const {serviceContract} = this.state;

    return (
      <Modal
        title="Activate Service"
        visible={visible}
        closable={false}
        footer={[
          <button key="cancel" className="btn btn-bdr" onClick={() => onCancel()}>Cancel</button>,
          <button key="save" className="btn btn-warning" onClick={() => onActiveService(serviceContract[0]?.imageUrl)}>Activate Service</button>
        ]}
      >
        <p>
          {"This proposal will be removed and you will be able to access this service under the customer's active profile."}
        </p>
        <p>
          Any Pet Waste Stations that may be required will be added to the kanban ready for scheduling and installation.
        </p>
        <b className="d-block mb-10">Contract:</b>
        <Upload
          name={'file'}
          beforeUpload={() => false}
          accept=".pdf,application/pdf"
          showUploadList={false}
          className="avatar-uploader"
          onChange={this.onUpload}>
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p>Drag and drop the service contract or <b>click here</b> to upload</p>
        </Upload>
      </Modal>
    );
  }
}

export default ActivateService;
